import { useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StopRecurringDialog = ({ invoiceId, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const stop = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/invoices/${invoiceId}/unmark-recurring`, { reason: reason.trim() || null });
      toast.success(data.message || "Recurring stopped");
      onDone?.();
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to stop recurring"); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid="stop-recurring-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Stop this recurring series?</AlertDialogTitle>
          <AlertDialogDescription>Future invoices and autopay will stop. Existing invoices and payments are kept.</AlertDialogDescription>
        </AlertDialogHeader>
        <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (optional)" data-testid="stop-recurring-reason" />
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="stop-recurring-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); stop(); }} disabled={busy} data-testid="stop-recurring-confirm">{busy ? "Stopping…" : "Stop recurring"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
